import React, { FC, useState } from 'react'
import { useInterval } from '@news-mono/web-common'
import { StyledBar, StyledEqualiserContainer } from './Equaliser.styled'

export interface EqualiserProps {
    widthInBars: number
    maxWaveHeight?: number
    volume?: number
    speed?: number
    color?: string
    skewed?: boolean
    className?: string
}

const easeOutQuad = (t: number) => 1 - --t * t * t * t

const getWaveHeights = (length: number, volume: number) =>
    Array.from({ length }).map(() =>
        Math.max(0, Math.random() * easeOutQuad(volume)),
    )

export const Equaliser: FC<EqualiserProps> = ({
    className,
    widthInBars,
    speed = 150,
    maxWaveHeight = 21,
    color,
    skewed,
    volume = 1,
}) => {
    const [waveHeights, setWaveHeights] = useState(
        getWaveHeights(widthInBars, volume),
    )

    useInterval(() => {
        setWaveHeights(getWaveHeights(widthInBars, volume))
    }, speed)

    return (
        <StyledEqualiserContainer
            aria-hidden={true}
            height={maxWaveHeight}
            skewed={skewed}
            className={`Equaliser ${className}`}
        >
            {waveHeights.map((height, key) => (
                <StyledBar
                    key={key}
                    backgroundColor={color}
                    skewed={skewed}
                    style={{ transform: `scale(1, ${height})` }}
                />
            ))}
        </StyledEqualiserContainer>
    )
}
